import L from 'leaflet'
import  'leaflet-geojson-vt/src/leaflet-geojson-vt.js'


export function createTileLayer(tileDetails) {
    if (!location.href.includes("localhost/")) {
      tileDetails.url = tileDetails.url.replace("static", "static.hollinshead.net");
    }
    return new L.TileLayer(tileDetails.url, tileDetails);
  }
  
 export function createVectorTileLayer(tileDetails) {
    const langStyleUrl = {
      'ga': '../maptilerstyle.json',
      'en': L.MaptilerStyle.BASIC
    }
    const lang = tileDetails.lang || 'en'
    return new L.MaptilerLayer({
      style: langStyleUrl[lang],
      apiKey: '0kGMUs4tUovitD5f8hid',
      maptilerLogo: false,
    });
  }
  